<template>
  <b-modal
    :id="modalId"
    class="customers-wrapper"
    size="lg"
    title="Edit Tier"
    centered
    no-close-on-backdrop
    @shown="setTier"
  >
    <div>
      <b-row no-gutters class="mb-2">
        <b-col md="4">
          <div class="primary-label">Prerequisite</div>
        </b-col>
        <b-col>
          <b-row>
            <b-col>
              <b-form-group label-for="select-tier">
                <div slot="label" class="secondary-label">Select Tier</div>
                <b-select
                  id="select-tier"
                  v-model="form.prerequisite_tier_uuid"
                  :disabled="!tierList.length"
                >
                  <option :value="null" disabled>Choose</option>
                  <option
                    :value="tier.uuid"
                    v-for="(tier, index) in tierList"
                    :key="index"
                  >
                    {{ tier.name }}
                  </option>
                </b-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr class="my-4" />
      <b-row no-gutters class="mb-2">
        <b-col md="4">
          <div class="primary-label">Basic Details</div>
        </b-col>
        <b-col>
          <b-row>
            <b-col>
              <b-form-group label-for="input-tier-name">
                <div slot="label" class="secondary-label">Tier Name</div>
                <b-input
                  id="input-tier-name"
                  v-model="form.name"
                  @keypress.native="filterAlphaNumeric"
                  :maxlength="nameCharLimit"
                  :class="{ 'border-danger': !!errors.name }"
                />
                <b-form-invalid-feedback :force-show="!!errors.name">
                  {{ errors.name }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label-for="input-description">
                <div slot="label" class="secondary-label">Description</div>
                <vue-editor
                  ref="descriptionEditor"
                  v-model="form.description"
                  :editorToolbar="descriptionEditorToolbar"
                  :class="{ 'border border-danger': !!errors.description }"
                  @text-change="onDescriptionChange"
                ></vue-editor>
                <small class="text-muted">
                  ({{ descriptionCharCount }} / 2000)
                </small>
                <b-form-invalid-feedback :force-show="!!errors.description">
                  {{ errors.description }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr class="my-4" />
      <b-row no-gutters class="mb-2">
        <b-col md="4">
          <div class="primary-label">Badge</div>
        </b-col>
        <b-col>
          <div class="secondary-label">Upload Image</div>
          <b-form-group>
            <div
              class="border rounded-circle badge-placeholder"
              v-b-modal.upload-badge-modal
              :class="{ 'border-danger': !!errors.badge_image_url }"
            >
              <template v-if="form.badge_image_url != '' && badge == null">
                <img :src="form.badge_image_url" alt="Badge" />
              </template>
              <template v-else>
                <img v-if="badge" :src="badge" alt="Badge" />
              </template>

              <div class="camera-icon rounded-circle border"></div>
            </div>
            <b-form-invalid-feedback :force-show="!!errors.badge_image_url">
              {{ errors.badge_image_url }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <hr class="my-4" />
      <!-- POINTS MECHANICS START <b-row no-gutters class="mb-2">
        <b-col md="4">
          <div class="primary-label">Mechanics</div>
        </b-col>
        <b-col>
          <b-row>
            <b-col>
              <b-form-group label-for="select-points-mechanics">
                <div slot="label" class="secondary-label">Points Mechanics</div>
                <b-select
                  id="select-points-mechanics"
                  v-model="form.mechanics_uuid"
                  :class="{ 'border-danger': !!errors.mechanics_uuid }"
                >
                  <option :value="null" disabled>Choose</option>
                  <option
                    v-for="(pointsMechanics, index) in pointsMechanicsList"
                    :key="index"
                    :value="pointsMechanics.uuid"
                  >
                    {{ pointsMechanics.name }}
                  </option>
                </b-select>
                <b-form-invalid-feedback :force-show="!!errors.mechanics_uuid">
                  {{ errors.mechanics_uuid }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr class="my-4" /> POINTS MECHANICS END-->
      <b-row no-gutters class="mb-2">
        <b-col md="4">
          <div class="primary-label">
            Points Requirements
            <i class="ic-tooltip" id="points-requirements-tooltip"></i>
            <b-popover
              target="points-requirements-tooltip"
              triggers="hover"
              position="top"
              content="Allows the end user to enter points requirements for the tier"
            >
            </b-popover>
          </div>
        </b-col>
        <b-col>
          <b-row>
            <b-col>
              <b-form-group label-for="input-points">
                <div slot="label" class="secondary-label">Points</div>
                <b-input-group prepend="Pts.">
                  <b-input
                    id="input-points"
                    v-model="form.points_requirement"
                    :class="{ 'border-danger': !!errors.points_requirement }"
                    @keypress.native="filterNumeric"
                  ></b-input>
                </b-input-group>
                <b-form-invalid-feedback
                  :force-show="!!errors.points_requirement"
                >
                  {{ errors.points_requirement }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row no-gutters class="mb-2">
        <b-col md="4">
          <div class="primary-label">
            Points Expiry
          </div>
          <switches
            v-model="form.points_expiry"
            id="toggle-points-expiry"
            theme="custom"
            color="primary"
            type-bold="true"
            text-enabled="On"
            text-disabled="Off"
            style="top: -5px"
            :emit-on-mount="false"
          />
        </b-col>
        <b-col>
            <b-form-group label-for="select-points-expiry-duration">
              <div slot="label" class="secondary-label">Validity</div>
              <b-select
                id="select-points-expiry-duration"
                :options="pointsExpiryDurationOptions"
                v-model="form.points_expiry_duration"
                :class="{
                  'border-danger': !!errors.points_expiry_duration,
                }"
                :disabled="!form.points_expiry"
              />
              <b-form-invalid-feedback :force-show="!!errors.points_expiry_duration">
                {{ errors.points_expiry_duration }}
              </b-form-invalid-feedback>
            </b-form-group>
        </b-col>
      </b-row>
      <hr class="my-4" />
      <b-row no-gutters class="mb-2">
        <b-col md="4">
          <div class="primary-label">
            Tier Validity
            <i class="ic-tooltip" id="tier-validity-tooltip"></i>
            <b-popover
              target="tier-validity-tooltip"
              triggers="hover"
              position="top"
              content="Allows the end user select the basis of the tier validity."
            >
            </b-popover>
          </div>
        </b-col>
        <b-col>
          <b-row>
            <b-col>
              <b-form-group label-for="select-duration">
                <div slot="label" class="secondary-label">Duration</div>
                <b-select
                  id="select-duration"
                  :options="durationOptions"
                  v-model="form.validity.duration"
                  :class="{
                    'border-danger': !!errors.duration,
                    'bg-light': isCycleExpirationDate,
                  }"
                  :disabled="isCycleExpirationDate"
                />
                <b-form-invalid-feedback :force-show="!!errors.duration">
                  {{ errors.duration }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col>
              <span class="secondary-label">Cycle Expiration Date</span>
              <i class="ic-tooltip" id="cycle-expiration-date-tooltip"></i>
              <b-popover
                target="cycle-expiration-date-tooltip"
                triggers="hover"
                position="top"
                content="Cycle Expiration Date"
              >
              </b-popover>
            </b-col>
            <b-col class="text-right">
              <switches
                id="toggle-cycle-expiration-date"
                v-model="isCycleExpirationDate"
                theme="custom"
                color="primary"
                type-bold="true"
                text-enabled="On"
                text-disabled="Off"
                style="top: -20px"
                :emit-on-mount="false"
                class="text-left"
              ></switches>
            </b-col>
          </b-row>
          <b-row v-if="isCycleExpirationDate" class="mb-4">
            <b-col>
              <b-form-group label-for="select-cycle-expiration-month">
                <div slot="label" class="secondary-label">Month</div>
                <b-select
                  id="select-cycle-expiration-month"
                  :options="cycleExpirationMonthsOptions"
                  v-model="form.validity.cycle_expiration.month"
                  :class="{
                    'border-danger': !!errors.cycle_expiration_month,
                  }"
                  @change="form.validity.cycle_expiration.day = null"
                />
                <b-form-invalid-feedback :force-show="!!errors.cycle_expiration_month">
                  {{ errors.cycle_expiration_month }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label-for="select-cycle-expiration-day">
                <div slot="label" class="secondary-label">Day</div>
                <b-select
                  id="select-cycle-expiration-day"
                  :options="cycleExpirationDaysOptions"
                  v-model="form.validity.cycle_expiration.day"
                  :class="{
                    'border-danger': !!errors.cycle_expiration_day,
                  }"
                  :disabled="!form.validity.cycle_expiration.month"
                />
                <b-form-invalid-feedback :force-show="!!errors.cycle_expiration_day">
                  {{ errors.cycle_expiration_day }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group>
                <b-form-radio 
                  v-model="activation_parameters" 
                  value="initial_transaction" 
                  class="d-block"
                >
                  Initial transaction
                </b-form-radio>

                <b-form-radio 
                  v-model="activation_parameters" 
                  value="date_registration" 
                  class="d-block"
                >
                  Date of registration
                </b-form-radio>

                <b-form-radio 
                  v-model="activation_parameters" 
                  value="estore_transaction" 
                  class="d-block"
                >
                  E-Store transaction
                </b-form-radio>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-invalid-feedback :force-show="!!errors.activation_parameters">
                {{ errors.activation_parameters }}
              </b-form-invalid-feedback>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr class="my-4" />
      <b-row no-gutters class="mb-2">
        <b-col md="4">
          <div class="primary-label">Rewards</div>
        </b-col>
        <b-col>
          <b-row>
            <b-container>
              <b-col>
                <b-row v-b-toggle="'rewards-collapse'" class="border py-2">
                  <b-col>{{
                    form.rewards_uuids.length
                      ? `${form.rewards_uuids.length} Selected`
                      : "Choose"
                  }}</b-col>
                  <b-col class="text-right"
                    ><img src="@/assets/images/dropdown.svg" alt="Dropdown"
                  /></b-col>
                </b-row>
                <b-row>
                  <b-collapse
                    id="rewards-collapse"
                    class="border w-100 border-0 pt-3"
                  >
                    <RewardsCheckbox
                      @checked="onCheckedRewards"
                      :reference="'rewards_uuids'"
                    />
                  </b-collapse>
                </b-row>
              </b-col>
            </b-container>
          </b-row>
        </b-col>
      </b-row>
      <hr class="my-4" />
      <b-row no-gutters>
        <b-col md="4">
          <div class="primary-label">
            Sub-Tier (Optional)
            <i class="ic-tooltip" id="sub-tier-tooltip"></i>
            <b-popover
              target="sub-tier-tooltip"
              triggers="hover"
              position="top"
              content="A minimum of 2 sub-tiers is required when adding a sub-tier."
            >
            </b-popover>
          </div>
        </b-col>
        <b-col>
          <b-row
            class="mb-4 border rounded"
            v-for="(subtier, index) in form.sub_tiers"
            :key="index"
          >
            <b-col>
              <b-row>
                <b-col cols="8" class="px-0">
                  <b-input
                    placeholder="Enter Sub-Tier Name"
                    class="font-weight-bold form-control"
                    v-model="subtier.name"
                    :class="
                      errors.sub_tiers &&
                      errors.sub_tiers[index] &&
                      errors.sub_tiers[index].name
                        ? 'border-danger'
                        : 'border-0'
                    "
                    :maxlength="nameCharLimit"
                    @keypress.native="filterAlphaNumeric"
                  ></b-input>
                </b-col>
                <b-col class="d-flex align-items-center justify-content-end">
                  <img
                    src="@/assets/images/actions/delete.svg"
                    alt="Delete"
                    class="cursor-pointer"
                    @click="deleteSubtier(index)"
                  />
                  <img
                    src="@/assets/images/dropdown.svg"
                    alt="Dropdown"
                    v-b-toggle="`subtier-collapse-${index}`"
                    class="cursor-pointer"
                  />
                </b-col>
              </b-row>
              <div
                v-if="
                  errors.sub_tiers &&
                  errors.sub_tiers[index] &&
                  errors.sub_tiers[index].name
                "
              >
                <b-form-invalid-feedback
                  :force-show="!!errors.sub_tiers[index].name"
                >
                  {{ errors.sub_tiers[index].name }}
                </b-form-invalid-feedback>
              </div>
              <b-row>
                <b-collapse
                  :id="`subtier-collapse-${index}`"
                  class="w-100 bg-light mt-2 py-4"
                  visible
                >
                  <b-container>
                    <div class="primary-label mb-2">Points Range</div>
                    <b-row>
                      <b-col>
                        <b-form-group :label-for="`minimum-points-${index}`">
                          <div slot="label" class="secondary-label">
                            Minimum Points
                          </div>
                          <b-input-group prepend="Pts.">
                            <b-input
                              :id="`minimum-points-${index}`"
                              v-model="subtier.min_points"
                              :class="{
                                'border-danger':
                                  errors.sub_tiers &&
                                  errors.sub_tiers[index] &&
                                  errors.sub_tiers[index].min_points,
                              }"
                              @keypress.native="filterNumeric"
                            ></b-input>
                          </b-input-group>
                          <div
                            v-if="
                              errors.sub_tiers &&
                              errors.sub_tiers[index] &&
                              errors.sub_tiers[index].min_points
                            "
                          >
                            <b-form-invalid-feedback
                              :force-show="!!errors.sub_tiers[index].min_points"
                            >
                              {{ errors.sub_tiers[index].min_points }}
                            </b-form-invalid-feedback>
                          </div>
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group :label-for="`maximum-points-${index}`">
                          <div slot="label" class="secondary-label">
                            Maximum Points
                          </div>
                          <b-input-group prepend="Pts.">
                            <b-input
                              :id="`maximum-points-${index}`"
                              v-model="subtier.max_points"
                              :class="{
                                'border-danger':
                                  errors.sub_tiers &&
                                  errors.sub_tiers[index] &&
                                  errors.sub_tiers[index].max_points,
                              }"
                              @keypress.native="filterNumeric"
                            ></b-input>
                          </b-input-group>
                          <div
                            v-if="
                              errors.sub_tiers &&
                              errors.sub_tiers[index] &&
                              errors.sub_tiers[index].max_points
                            "
                          >
                            <b-form-invalid-feedback
                              :force-show="!!errors.sub_tiers[index].max_points"
                            >
                              {{ errors.sub_tiers[index].max_points }}
                            </b-form-invalid-feedback>
                          </div>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-container>
                        <b-col>
                          <b-row
                            v-b-toggle="`rewards-collapse-${index}`"
                            class="border py-2 bg-white"
                            :class="{
                              'border-danger':
                                errors.sub_tiers &&
                                errors.sub_tiers[index] &&
                                errors.sub_tiers[index].rewards_uuids,
                            }"
                          >
                            <b-col>
                              <div>
                                {{
                                  subtier.rewards_uuids.length
                                    ? `${subtier.rewards_uuids.length} Selected`
                                    : "Choose"
                                }}
                              </div>
                            </b-col>
                            <b-col
                              v-if="errors.sub_tiers && errors.sub_tiers[index]"
                            >
                              <b-form-invalid-feedback
                                :force-show="
                                  !!errors.sub_tiers[index].rewards_uuids
                                "
                              >
                                {{ errors.sub_tiers[index].rewards_uuids }}
                              </b-form-invalid-feedback>
                            </b-col>
                            <b-col class="text-right" cols="2"
                              ><img
                                src="@/assets/images/dropdown.svg"
                                alt="Dropdown"
                            /></b-col>
                          </b-row>
                          <b-row class="border border-top-0">
                            <b-collapse
                              :id="`rewards-collapse-${index}`"
                              class="border w-100 border-0 pt-3 bg-white"
                            >
                              <RewardsCheckbox
                                @checked="onCheckedRewards"
                                :reference="`sub_tiers[${index}].rewards_uuids`"
                              />
                            </b-collapse>
                          </b-row>
                        </b-col>
                      </b-container>
                    </b-row>
                  </b-container>
                </b-collapse>
              </b-row>
            </b-col>
          </b-row>
          <b-form-invalid-feedback
            :force-show="!!errors.sub_tiers_min"
            class="mb-4"
          >
            {{ errors.sub_tiers_min }}
          </b-form-invalid-feedback>
          <b-form-invalid-feedback
            :force-show="
              !!errors.sub_tiers && typeof errors.sub_tiers === 'string'
            "
            class="mb-4"
          >
            {{ errors.sub_tiers }}
          </b-form-invalid-feedback>
          <b-row>
            <b-col>
              <b-btn
                variant="primary"
                class="btn-add-outline"
                @click="addSubtier"
                >Add New Sub-Tier</b-btn
              >
            </b-col>
          </b-row>
          <b-row class="mt-4" v-if="form.sub_tiers.length">
            <b-col>
              <div class="primary-label">
                Display sub-tier name
                <i class="ic-tooltip" id="display-subtier-name-tooltip"></i>
                <b-popover
                  target="display-subtier-name-tooltip"
                  triggers="hover"
                  position="top"
                  content="Display sub-tier name in customer app and web"
                >
                </b-popover>
              </div>
            </b-col>
            <b-col class="text-right">
              <switches
                id="toggle-display-sub-tier-name"
                v-model="displaySubtierName"
                theme="custom"
                color="primary"
                type-bold="true"
                text-enabled="On"
                text-disabled="Off"
                style="top: -24px"
                :emit-on-mount="false"
                class="text-left"
              ></switches>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <div slot="modal-footer" class="w-100">
      <b-container fluid>
        <b-row mt-6>
          <b-col xs="12" md="4" class="mb-3 mb-md-0">
            <b-btn
              variant="ghost"
              class="btn-block btn-cancel"
              @click="$root.$emit('bv::hide::modal', modalId)"
            >
              Cancel
            </b-btn>
          </b-col>
          <b-col xs="12" md="4" class="ml-md-auto text-md-right">
            <b-btn
              variant="primary"
              class="btn-block"
              @click="saveTier"
              :disabled="isLoading"
            >
              {{ isLoading ? "Saving" : "Save" }}
            </b-btn>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </b-modal>
</template>
<script>
import { set, isEmpty } from "lodash";
import moment from "moment";
import notification from "@/services/notification";
import { VueEditor } from "vue2-editor";
import Switches from "vue-switches-2";
import { mapState, mapActions, mapMutations } from "vuex";
import RewardsCheckbox from "./RewardsCheckbox";
import { mapFields } from "vuex-map-fields";

const form = {
    prerequisite_tier_uuid: null,
    type: "",
    name: "",
    description: "",
    badge_image_url: "",
    // mechanics_uuid: null,
    points_requirement: "",
    validity: {
        duration: null,
        activation_parameters: {
            initial_transaction: false,
            date_registration: false,
            estore_transaction: false
        },
        cycle_expiration: {
            month: null,
            day: null
        }
    },

    rewards_uuids: [],
    sub_tiers: [],
    points_expiry: false,
    points_expiry_duration: null
};

export default {
    name: "editMembershipTier",
    data() {
        return {
            modalId: "edit-membership-tier-modal",
            nameCharLimit: 30,
            descriptionCharLimit: 2000,
            tierOptions: [
                { value: null, text: "Choose", disabled: true },
                { value: "basic", text: "Basic" },
                { value: "silver", text: "Silver" },
                { value: "gold", text: "Gold" },
                { value: "platinum", text: "Platinum" }
            ],
            durationOptions: [
                { value: null, text: "Choose", disabled: true },
                { value: "3", text: "3 months" },
                { value: "6", text: "6 months" },
                { value: "12", text: "1 year" },
                { value: "24", text: "2 years" }
            ],
            cycleExpirationMonthsOptions: [
                { value: null, text: "Choose", disabled: true },
                { value: 1, text: "January" },
                { value: 2, text: "February" },
                { value: 3, text: "March" },
                { value: 4, text: "April" },
                { value: 5, text: "May" },
                { value: 6, text: "June" },
                { value: 7, text: "July" },
                { value: 8, text: "August" },
                { value: 9, text: "September" },
                { value: 10, text: "October" },
                { value: 11, text: "November" },
                { value: 12, text: "December" }
            ],
            isCycleExpirationDate: false,
            descriptionEditorToolbar: [
                [{ size: [] }],
                [{ color: [] }],
                ["bold", "italic", "underline", "strike"],
                [{ align: ["", "center", "right", "justify"] }]
            ],
            selectedSubtierRewards: [],
            displaySubtierName: false,
            rewardsList: [],
            rewardsPage: 1,
            form,
            original_badge_image_url: "",
            activation_parameters: null,
            pointsExpiryDurationOptions: [
                { value: "+3 months", text: "3 Months" },
                { value: "+6 months", text: "6 Months" },
                { value: "+1 year", text: "1 Year" },
                { value: "+2 years", text: "2 Years" },
                { value: "+3 years", text: "3 Years" },
                { value: "+4 years", text: "4 Years" },
                { value: "+5 years", text: "5 Years" },
                { value: "+10 years", text: "10 Years" },
                { value: "+15 years", text: "15 Years" }
            ]
        };
    },
    methods: {
        ...mapActions("programMembershipTiers", [
            // "getPointsMechanicsList",
            "updateTier",
            "getTierList"
        ]),
        ...mapMutations("programMembershipTiers", ["setErrors"]),
        onDescriptionChange() {
            if (this.descriptionCharCount > this.descriptionCharLimit)
                this.$refs.descriptionEditor.quill.deleteText(
                    this.descriptionCharLimit,
                    this.descriptionCharCount
                );
        },
        isImageUrl(item) {
            return item.includes("data:image");
        },
        onCheckedRewards({ reference, selectedRewards }) {
            set(this.form, reference, selectedRewards);
        },
        isNotAlphaNumeric(input) {
            return /[^A-Za-z0-9\s]+/g.test(input);
        },
        filterAlphaNumeric(e) {
            if (this.isNotAlphaNumeric(String.fromCharCode(e.keyCode)))
                e.preventDefault();
        },
        isNotNumeric(input) {
            return /[^0-9]/g.test(input);
        },
        filterNumeric(e) {
            if (this.isNotNumeric(String.fromCharCode(e.keyCode)))
                e.preventDefault();
        },
        addSubtier() {
            this.form.sub_tiers.push({
                name: "",
                min_points: null,
                max_points: null,
                rewards_uuids: [],
                is_display_name: false
            });
        },
        deleteSubtier(index) {
            if (!this.form.sub_tiers.length) return;

            this.form.sub_tiers.splice(index, 1);
        },
        setTier() {
            this.original_badge_image_url = this.tier.badge_image_url;
            this.form = { ...form, ...this.tier };
            this.isCycleExpirationDate = !this.form.validity.duration;

            const obj = this.form.validity.activation_parameters;
            const validity = Object.keys(obj).find(key => obj[key] === true);
            this.activation_parameters = validity || null;
        },
        saveTier() {
            const errors = {};
            const requiredFieldSpiel = "This field is required.";
            const alphaNumericSpiel = "Must be alphanumeric.";
            const numericSpiel = "Must be numeric.";
            const minSubtiersSpiel = "A minimum of 2 sub-tiers is required.";
            const invalidMinPointsSpiel = "Must be less than max points";

            if (!this.form.name) errors.name = requiredFieldSpiel;

            if (this.isNotAlphaNumeric(this.form.name))
                errors.name = alphaNumericSpiel;

            if (!this.form.description) errors.description = requiredFieldSpiel;

            if (this.descriptionCharCount > this.descriptionCharLimit)
                errors.content = `Up to ${
                    this.descriptionCharLimit
                } characters only`;

            if (this.badge && this.isImageUrl(this.badge))
                this.form.badge_image_url = this.badge.split(",").pop();

            if (!this.form.badge_image_url)
                errors.badge_image_url = requiredFieldSpiel;

            // if (!this.form.mechanics_uuid) errors.mechanics_uuid = requiredFieldSpiel;

            if (!this.form.points_requirement)
                errors.points_requirement = requiredFieldSpiel;

            if (
                this.form.points_requirement &&
                this.isNotNumeric(this.form.points_requirement)
            )
                errors.points_requirement = numericSpiel;

            if (!this.isCycleExpirationDate && !this.form.validity.duration)
                errors.duration = requiredFieldSpiel;

            if (this.isCycleExpirationDate) {
                if (!this.form.validity.cycle_expiration.month)
                    errors.cycle_expiration_month = requiredFieldSpiel;
                if (!this.form.validity.cycle_expiration.day)
                    errors.cycle_expiration_day = requiredFieldSpiel;
            }

            if (this.form.sub_tiers.length === 1)
                errors.sub_tiers_min = minSubtiersSpiel;

            if (this.form.sub_tiers.length) {
                errors.sub_tiers = [];
                let totalSubtierPoints = 0;

                this.form.sub_tiers.map(subtier => {
                    const error = {};

                    if (!subtier.name) error.name = requiredFieldSpiel;

                    if (subtier.name && this.isNotAlphaNumeric(subtier.name))
                        error.name = alphaNumericSpiel;

                    if (!subtier.min_points)
                        error.min_points = requiredFieldSpiel;

                    if (
                        subtier.min_points &&
                        this.isNotNumeric(subtier.min_points)
                    )
                        error.min_points = numericSpiel;

                    if (!subtier.max_points)
                        error.max_points = requiredFieldSpiel;

                    if (
                        subtier.max_points &&
                        this.isNotNumeric(subtier.max_points)
                    )
                        error.max_points = numericSpiel;

                    if (
                        subtier.min_points &&
                        subtier.max_points &&
                        !this.isNotNumeric(subtier.min_points) &&
                        !this.isNotNumeric(subtier.max_points) &&
                        parseInt(subtier.min_points) >=
                            parseInt(subtier.max_points)
                    ) {
                        error.min_points = invalidMinPointsSpiel;
                    }

                    if (!subtier.rewards_uuids.length)
                        error.rewards_uuids = requiredFieldSpiel;

                    if (Object.keys(error).length) errors.sub_tiers.push(error);
                    else errors.sub_tiers.push({});

                    if (
                        subtier.max_points &&
                        !this.isNotNumeric(subtier.max_points)
                    ) {
                        totalSubtierPoints =
                            totalSubtierPoints + parseInt(subtier.max_points);
                    }
                });

                if (
                    errors.sub_tiers.every(
                        error => Object.keys(error).length === 0
                    )
                )
                    delete errors.sub_tiers;
            }

            if (
                (this.form.validity.duration || this.isCycleExpirationDate) &&
                !Object.values(
                    this.form.validity.activation_parameters
                ).includes(true)
            )
                errors.activation_parameters =
                    "At least one tier activation trigger is required.";

            if (this.form.points_expiry && !this.form.points_expiry_duration)
              errors.points_expiry_duration = requiredFieldSpiel;

            this.setErrors(errors);

            if (Object.keys(errors).length) {
                notification.warning("Oops, cannot update tier.");

                return;
            }

            this.form.type = this.form.name;

            if (!this.badge) this.form.badge_image_url = null;

            if (this.isCycleExpirationDate) this.form.validity.duration = 0;

            if (this.form.sub_tiers.length)
                this.form.sub_tiers.map(
                    subtier =>
                        (subtier.is_display_name = this.displaySubtierName)
                );

            this.updateTier(this.form).then(() => {
                if (isEmpty(this.errors)) {
                    this.$root.$emit("bv::hide::modal", this.modalId);
                    this.getTierList();
                } else
                    this.form.badge_image_url = this.original_badge_image_url;
            });
        }
    },
    computed: {
        ...mapState("programMembershipTiers", [
            // "pointsMechanicsList",
            "tier",
            "errors",
            "tierList",
            "isLoading",
            "badge"
        ]),
        ...mapFields("programMembershipTiers", ["tier"]),
        descriptionCharCount() {
            return this.form.description.replace(/<[^>]*>?/gm, "").trim()
                .length;
        },
        cycleExpirationDaysOptions: {
            get() {
                return !this.form.validity.cycle_expiration.month
                    ? [{ value: null, text: "Choose", disabled: true }]
                    : [
                          { value: null, text: "Choose", disabled: true },
                          ...Array.from(
                              Array(
                                  moment(
                                      `${moment().year()}-${
                                          this.form.validity.cycle_expiration
                                              .month
                                      }`
                                  ).daysInMonth()
                              ),
                              (_, day) => (day++ + 1 < 10 ? day++ : day++)
                          )
                      ];
            }
        }
    },
    watch: {
        isCycleExpirationDate(value) {
            if (value) {
                this.form.validity.duration = null;
                this.form.validity.activation_parameters.initial_transaction = false;
                this.form.validity.activation_parameters.date_registration = false;
                this.form.validity.activation_parameters.estore_transaction = false;
            } else {
                this.form.validity.cycle_expiration = {
                    month: null,
                    day: null
                };
            }
        },
        activation_parameters() {
            if (this.activation_parameters === null) return;

            this.form.validity.activation_parameters.initial_transaction = false;
            this.form.validity.activation_parameters.date_registration = false;
            this.form.validity.activation_parameters.estore_transaction = false;

            this.form.validity.activation_parameters[
                this.activation_parameters
            ] = true;
        },
        "form.points_expiry"(value) {
          if (!value) this.form.points_expiry_duration = null;
        }
    },
    components: {
        Switches,
        VueEditor,
        RewardsCheckbox
    }
};
</script>
<style lang="scss">
</style>
